export default "__VITE_ASSET__Mx5Eqhy$__";